import axios from "axios";
export default {
    getNodeContent: (nodeId) => axios.post("/Documents/DocumentObjectNodeContents", { nodeId }),
    getContentChildren: (nodeId) => axios.post("/Documents/GetDocumentContentChildren", { nodeId }),
    getContentMasters: (documentId) => axios.post("/Documents/GetDocumentContentMasters", { documentId }),
    getComments: (nodeId, documentId) => axios.post("/Documents/GetSocialComments", { nodeId, documentId }),
    getLikes: (nodeId, documentId) => axios.post("/Documents/GetSocialLikes", { nodeId, documentId }),
    getDocumentContentData: (documentId) => axios.post("/Documents/GetDocumentContentData", { documentId }),
    saveDocumentContentData: (document) => axios.post("/Documents/SaveDocumentContentData", document),
    getImageContentValue: (nodeId, contentId) => axios.post("/Documents/GetImageContentValue", { nodeId, contentId }),
    getTextContentValue: (nodeId, contentId) => axios.post("/Documents/GetTextContentValue", { nodeId, contentId }),
    buildAudioContentValueUrl: (nodeId, contentId) => `/Documents/GetAudioContentValue/${nodeId}/${contentId}`,
    buildVideoContentValueUrl: (nodeId, contentId) => `/Documents/GetVideoContentValue/${nodeId}/${contentId}`
};
